import { styled } from "@mui/material/styles";
import { Chip } from "@mui/material";

export const StyledStatusChip = styled(Chip)(() => ({
  fontWeight: 600,
  borderRadius: "12px",
  margin: 0,
  height: "15px",
  fontSize:"0.5rem"
}));
